import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

export const createSection = createAsyncThunk(
	"createSection",
	async ({ data, onSuccess }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.post(`section/create`, data);
			message.success("Section successfully created!");
			if (onSuccess) {
				onSuccess();
			}
			return response.data;
		} catch (err) {
			if (!err.response) {
				throw err;
			}
			message.error(err.response.data.message || "Failed to create section");
			return rejectWithValue(err.response.data);
		}
	}
);

const sectionCreateSlice = createSlice({
	name: "sectionCreate",
	initialState: {
		isLoading: false,
		error: null,
		data: null,
	},

	extraReducers: (builder) => {
		builder.addCase(createSection.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});
		builder.addCase(createSection.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(createSection.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default sectionCreateSlice.reducer;
